import { IApiResponse, INameExists } from 'src/app/Shared/interface';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AppInsightsService } from '../app-insights.service';
import { ICustomerListInAutopayNotPaid, ISavePaymentDetails, ITemplateMergeFields, IPaymentDetails } from 'src/app/Shared/interface2';
import {AppService} from '../app.service';
import { FingerPrintService } from '../fingerPrint/fingerprint.service';


@Injectable({
    providedIn: 'root',
})

export class MakePaymentService {
    private baseURL = this.appService.config.apiBaseUrl;

    private options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

    constructor(private http: HttpClient,
                private appinsights: AppInsightsService,
                private appService: AppService,
                public fingerPrintService: FingerPrintService) { }


    SavePaymentDetails(savePaymentDetails: ISavePaymentDetails[]): Observable<IPaymentDetails> {
        let options ={};
        if(this.fingerPrintService.isFingerPrintUsed) {
            options = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'secondary_userId': `${this.fingerPrintService.userId}` }) };
        } else {
            options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        }
        let url = `${this.baseURL}/MakePayment/SavePaymentDetails`;

        return this.http.post<IPaymentDetails>(url, savePaymentDetails, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }
    UpdatePaymentReceiptBlobReference(receiptNumber, receiptURL): Observable<any> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), };
        let url = `${this.baseURL}/MakePayment/UpdatePaymentReceiptBlobReference?receiptNumber=${receiptNumber}&receiptURL=${receiptURL}`;

        return this.http.post<any>(url, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }
    getLedgerBreakDown(inputObj): Observable<any> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), };
        let url = `${this.baseURL}/MakePayment/GetDynamicLedger`;

        return this.http.post<any>(url, inputObj, options).pipe(map(resp => {
            return resp;
        }),
            catchError(this.handleError)
        );
    }

    getLateAndLienSettings(facId): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/Prospects/GetFacilityLateandLienSettings?facilityId=${facId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const lateAndLien = res.body as any;
                    return lateAndLien;
                }),
                catchError(this.handleError)
            );
    }

    getAdminFacilityLateandLienSetting(facId) {
        return this.http.get<any>(
            `${this.baseURL}/LateandLien/FacilityLateandLienSetting?facilityId=${facId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const lateAndLien = res.body as any;
                    return lateAndLien;
                }),
                catchError(this.handleError)
            );
    }

    
    processBatchStripepayment(savePaymentDetails: any): Observable<any> {
        let options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = `${this.baseURL}/MakePayment/ProcessStripeBatchPayment`;

        return this.http.post<any>(url, savePaymentDetails, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    private handleError(error: HttpErrorResponse) {
        console.error('server error:', error);
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            this.appinsights.logEvent(errMessage);
            return throwError(errMessage);
        }
        return throwError(error || 'Node.js server error');
    }

}
